<template>
  <div>
    <header>
      <app-navigation>
        <h1 id="logo_monito"><a href="https://monito.com?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Monito</a></h1>
        <ul>
          <li><a href="https://www.monito.com/en/about-monito?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">About us</a></li>
          <li><a href="https://www.monito.com/en/wiki/monito-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Alerts</a></li>
          <li><a href="https://www.monito.com/en/wiki?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=nav">Wiki</a></li>
          <li class="langage"><a href="#">EN</a></li>
        </ul>
      </app-navigation>
    
	<app-hero-section :urlBackground="urlBackground" :herotype="herotype"></app-hero-section>	

  </header>

  <main ref="main">
    <section ref="scroll_zone" >
    <section class="
      boxed has-cover
      pt-57 pl-7 pr-7 pb-10
      pl-lg-5 pr-lg-5 pb-lg-8
      pl-md-5 pr-md-5 pb-md-8
      pl-sm-3 pr-sm-3 pb-sm-7 
      mt-5 mb-5">
        <div class="color"></div>
        <div class="cover" style="background-image:url('https://maltawinds.com/wp-content/uploads/2017/02/brexit-640x360.jpg');"></div>

        <h1 id="anchor01" class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">How to open a bank account online in the UK (even without proof of residency)</h1>
        <div class="aside_widget mb-4 mb-sm-0">
          <div class="should excellent">
            <p><span>What you should do</span><b>Take your banking 100% online with TransferWise.</b> Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.</p>
              <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=headerro_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Take me to TransferWise</a>
    </div>
        </div>
        <div v-if="false" class="aside_widget">
          <div class="should bad">
            <p><span>What you should avoid</span><b>Don’t go with a high-street bank,</b> most won’t allow you to open a bank account without a proof of residency and are all around more expensive.</p>
          </div>
        </div>
        <widget-author class="mb-6 mt-3">
          <div class="portrait">
            <span class="image" style="background-image:url('https://images.prismic.io/monito%2F7924bad3-5587-466e-8147-b095f0bb33f3_francois+profile+picture.jpg?auto=compress,format&rect=0,105,1401,1401&w=200&h=200');"></span>
            <p class="name pt-sm-2"><span>Written by</span><a href="https://www.monito.com/en/wiki/francois-briod?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=main_content">François Briod</a></p>
            <p class="pb-sm-3 update"><span>Last updated</span>April 16, 2020</p>
          </div>
          <p class="bio mt-2 mb-2 ls-2 pl-sm-1 fw-medium mb-sm-3 f-anti">Co-Founder of Monito and money transfer expert, François has been helping Monito’s users navigate the jungle of money transfer fees, bad exchange rates and tricks for the last six years.</p>
        </widget-author>

        <p class="f_body">Considering a move to the UK? Whether you are moving as a student to attend university, for a new job or to look for work, you may want a local bank account in order to get yourself set up. And in case you heard horror stories about setting up a UK bank account, don’t worry too much.</p>

        <p class="f_body">Other country guides: <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">How to open a bank account in the US,</a> <a href="https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Canada </a>or <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Australia</a> as a non-resident.</p>

        <p class="f_body">It used to be notoriously tough to get an account, but it’s recently become more straightforward. Plus, if you are a digital nomad without a fixed address, just want an&nbsp;<a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">international bank account</a>&nbsp;or struggle to prove that you are a UK resident because you’re lacking specific documentation, there are now a number of alternatives. &nbsp;Or if the mere thought of relocation admin makes you cringe, don’t fret: There are also a few resources (for a fee, of course!) that will help you with the process of opening a bank account in the UK.</p>

        <h2 class="f_subtitle_1">Major traditional banks in the UK or Online Banks?</h2>
        <p class="f_body">The biggest traditional banks in the UK are HSBC, Lloyds, Royal Bank of Scotland (often referred to as simply RBS), Barclays, NatWest, Santander and Nationwide. By traditional, we mean banks with actual physical branches across the country (versus, say, online banks which provide a UK bank account with a UK account). </p>
        <p class="f_body">Online bank accounts are great if you simply need to have an account in Pound Sterling with a UK account number and sort code, and many, like <a href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F">TransferWise’s Borderless Account</a>, also offer debit cards. But if you want or need a bank where you can actually walk into a branch, then you’ll want to consider a traditional bank.</p>

        <h2 class="f_subtitle_1">Types of UK accounts</h2>
        <p class="f_body">There are numerous types of accounts in the UK, but a standard current bank account is what most people want to for basic everyday use such as paying bills and receiving a salary. These accounts generally come with a debit card, a check book and overdraft protection. Savings accounts yield a higher interest rate and are meant for what their name implies—saving money. </p>
         <p class="f_body">There are also basic accounts, which are generally on offer for people with a poor credit history.</p>
         <h3 class="f_subtitle_1">Documents you need to open a UK bank account</h3>
         <p class="f_body">In order to open a UK bank account, you generally need two things:</p>

         <p class="f_body">Proof of your identity. This can take the form of a passport, drivers licence or national identity card. In general, if you are a foreign national your best bet is to use your passport — EU national identity cards are usually accepted (though how this works after Brexit takes effect is anyone’s guess), but if you are from, say, Australia, your home drivers license may not be accepted.</p>
         <p  class="f_body">Proof of address. This is generally a recent utility bill, rental contract, council tax bill. Mobile phone bills are generally not accepted.</p>
         <div id="anchor02" ref="anchor02"  >
          <h3 class="f_subtitle_1 mb-6">Monito’s experts recommendations</h3>
          <div class="should_content excellent mt-3">
           <h3 class="mb-2">What you should do</h3>
           <p class="f_body">We've compared the available online banking options for your current situation and TransferWise is the simplest option to pay and get paid like a local in the UK.</p>
           <h4 class="f_chapo">Why TransferWise ?</h4>
           <ul class="f_body">
             <li>Their pricing is 100% transparent and very competitive</li>
             <li>Hold money in GBP and 50 other currencies</li>
             <li>No setup fees or monthly charges</li>
             <li>You don't need to have a UK to open the account.</li>
           </ul>
           <div class="center"><a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-17 ls-1">Take me to TransferWise</a></div>
          </div>
          <div class="should_content bad mt-4">
           <h3 class="mb-2">What you should avoid</h3>
           <p class="f_body">Avoid opening an account at a high-street bank, even if you have proof of residency we still belive its a much less convenient way to do banking while you're living abroadin the UK.</p><p class="f_body">An online bank (like the ones we're compared below) is your best option to be in full control of the multiple currencies you have.</p>
          </div>
         </div>
    </section>
    <section id="anchor03" ref="anchor03"  class="
      boxed 
      pt-4 pl-7 pr-7 pb-10
      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8
      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 
      mt-5 mb-5">
      <div class="color"></div>
      <h2 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">How to open a UK account without proof of residency</h2>
         
      <p class="f_body">If you want to open a bank-like UK account without proof of address,&nbsp;<a href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=main_content&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F">TransferWise</a>, <a href="https://www.monito.com/en/send-money-with/monese?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Monese</a>, <a href="https://www.monito.com/en/send-money-with/revolut?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Revolut</a> and&nbsp;<a href="https://monzo.com/blog/2018/09/07/open-a-uk-bank-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Monzo</a>&nbsp;are a few online services that will set up a UK account without proof of residency.&nbsp;All offer UK account numbers and sort codes as well as debits cards you can use in retailers or to pay for items online. Keep in mind that local withdrawals may come with limitations or costs. However, if you want more flexibility, most of them offers the option to&nbsp;upgrade to fee-based accounts with higher limits and more features. If you’re having trouble deciding which is best for you, <a href="https://www.monito.com/en/wiki/monese-vs-monzo?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Monzo versus Monese</a>, here’s a round-up of what each offer. Note that even though you don’t have to submit a proof of address, you’ll still need to supply a UK address–this is also where your debit card will be delivered.</p>
      <img src="https://images.prismic.io/monito/2480ea46-72c1-421c-a46d-e7822f62a134_transferwise_borderless_account_digital_nomads.jpg" class="mt-6 mt-6-sm"/>
      <label class="ls-1 mb-2-sm fw-demi-bold f6">© TransferWise</label>
      <p class="f_body"><a href="https://www.monito.com/en/send-money-with/transferwise-borderless?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">TransferWise Borderless</a> Account and card let you pay and get paid like a local in the UK. After opening your account online, you'll need to verify your identity through their interface. If you don't have a proof of address yet, here's what <a href="https://go.monito.com/transferwise-borderless?link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3AAA%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fblog%252Fhow-to-get-proof-of-address-uk">TransferWise says</a>: "You can then choose to either supply a proof of address from a standard list of documents, or to send in a selfie, in which you’re holding your proof of ID. This can be a great alternative, if you’re still waiting to move to the UK, or haven’t yet got bills and other paperwork registered in your name."</p>
         <p class="f_chapo">Once done, here's what you'll get with a TransferWise borderless account:</p>
         <ul class="f_body"><li>Local bank details in the US, Eurozone, UK, Australia, New Zealand and Poland to get paid like a local. </li><li>An account to hold up to 40 currencies free and great rates to convert between them.</li><li>A multi-currency Mastercard debit card great for paying in foreign currencies without the hidden fees</li><li>Access to TransferWise's powerful international money transfer service right from your account balance.</li></ul>
         <p  class="f_chapo">Let's say that you've just moved from France to the UK and you need GBP. With a borderless account, you can now:</p><ul style="list-style-type: lower-roman;" class="f_body"><li> send EURO from your regular account to your TransferWise Euro account for free</li><li>convert all or part of it to GBP for a low fee (0.41% or a £4.08 to convert 1,000 EUR to GBP)</li><li>pay with your TransferWise Debit card, set-up direct debit with UK provider to pay your bills or make a local transfer for free (to pay rent for example)<br><br>You'll also have UK bank details to share with an employer. </li></ul>
       
        <img src="https://images.prismic.io/monito/4e3f022f776b6ca602f1f35c718e10af813f2a0e_chrome_2019-07-09_12-04-23.png" class="mt-6 mt-6-sm"/>
        <p class="f_body"><a target="_blank" rel="noopener" href="https://go.monito.com/monese">Monese</a>&nbsp;is an entirely mobile bank, enabling you to do everything from the Monese app. You can also transfer money into 15 different currencies (including Euros and US Dollars) at the standard&nbsp;<a href="https://www.monito.com/en/wiki/mid-market-exchange-rate?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">mid-market exchange rate</a>. It’s is a handy feature if you need to send money overseas or pay bills (say a mortgage) abroad. They offer three types of current accounts:</p>
        <ul class="f_body"><li><strong>Simple:&nbsp;</strong>If you want to limit the up-front costs, go for the Starter account. It’s a full UK current account with no monthly costs and includes a free debit card, but they charge £1 per withdrawal from UK ATMs and a 2% fee on foreign currency exchange transfers.</li><li><strong>Classic:</strong>&nbsp;Plus accounts cost £5.95 per month and allow up to 6 free UK ATM withdrawals per month, after that they cost £1 each until the end of the month. Foreign currency exchange transfers incur a 0.5% fee. As with the Starter account, it’s a full UK account with a free debit card.</li><li><strong>Premium:</strong>&nbsp;Premium accounts cost £14.95 per month and unlimited UK ATM withdrawals per month and free foreign currency exchange transfers. Again, it’s a full UK account with a free debit card.</li></ul>
        
        <img src="https://images.prismic.io/monito/e07dae9a32d5c3f76674811cff7f1da23c7fa405_monzo-1.jpeg" class="mt-6 mt-6-sm"/>
        <p class="f_body"><a target="_blank" rel="noopener" href="https://monzo.com/?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Monzo</a>&nbsp;is also a mobile bank that includes a full UK current account and debit card, with everything controlled via their app. They allows up to&nbsp;£200 per month in free withdrawals in both the UK and abroad–after that you’ll be slapped with a 3% fee for each withdrawal you make until the end of the month. Paying with your debit card is free though, including when you are abroad, which is a great perk. Unlike Monese, Monzo only offers one type of account.<br></p>
        <img src="https://images.prismic.io/monito/14f6d7a6f864cecd0e4eaac8c333a0159a63e0a3_revolut2.jpeg" class="mt-6 mt-6-sm"/>
        <label class="ls-1 mb-2-sm fw-demi-bold f6">© Revolut</label>
        <p class="f_body"><a href="https://www.monito.com/en/send-money-with/revolut?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Revolut </a>is a digital banking alternative that enables opening a UK current account without proof of residency plus a debit card. &nbsp;You can also transfer at the standard&nbsp;<a href="https://www.monito.com/en/wiki/mid-market-exchange-rate">mid-market exchange rate</a>&nbsp;and hold money in over 20 currencies. &nbsp;They offer several types of accounts:</p>
        <ul class="f_body"><li><strong>Standard:&nbsp;</strong>With zero up-front costs, the Standard option offers a full UK current (plus an IBAN) account with no monthly costs and includes a free debit card, but they charge no fee UK ATM withdrawals up to £200 per month, after that it costs&nbsp;2% of value of the ATM withdrawal.</li><li><strong>Premium:</strong>&nbsp;Premium accounts cost £6.99 per month including a debit card and they charge no fee UK ATM withdrawals up to £400 per month, after that it costs&nbsp;2% of value of the ATM withdrawal.</li><li><strong>Metal:</strong>&nbsp;Metal accounts cost £12.99 per month including a debit card and they charge no fee UK ATM withdrawals up to £600 per month, after that it costs&nbsp;2% of value of the ATM withdrawal.</li></ul>
        <img src="https://images.prismic.io/monito/ac793bc15e80e2db2cf80c30d662c01d23444ed5_kickstart_1st_contact.jpeg" class="mt-6 mt-6-sm"/>
        <p class="f_subtitle_2">Pay someone to sort out all the details</p>
        <p class="f_body">If merely thinking about all of the above options makes you lose your marbles, check out&nbsp;<a target="_blank" rel="noopener" href="https://www.1stcontact.com/kickstart/bank-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">1st Contact</a>. The company has relationships with several traditional banks including Lloyds and HSBC and facilitates an introduction to the banks, enabling you to open a UK bank account without the usual proof of residency documents like a utility bill.&nbsp;<br></p>
        <p class="f_body"><strong>1stContact</strong>&nbsp;offers several packages which includes:</p>
        <ul class="f_body"><li><strong>UK bank account only:</strong>&nbsp;If you just want to open a UK bank account, you can pay&nbsp;<strong>£25&nbsp;</strong>and get a UK bank account without proof of residency. You just have to provide a valid passport, proof of permission to live and work in the UK, a residential address where you can receive post (this can be a friend or relative you are staying with, you don’t need a utility bill), be 18 or older and able to attend an appointment in London with one of their banking affiliates.</li><li><strong>Kickstart Classic UK package:</strong>&nbsp;if you would like UK bank account plus, various bells and whistles, go for the Kickstart package for&nbsp;<strong>£35</strong>. It includes a bank account, a UK mobile phone SIM, guides to living and working in the UK, a DIY help guide that may provide assistance obtaining a National Insurance (NI) number, help creating a CV, and a free international money transfer, a 5 day gym membership, accommodation assistance and tour discount vouchers.&nbsp;</li><li><strong>Tier5 Visa Kickstart package:</strong>&nbsp;If you want all of the above (including a UK bank account) PLUS help applying for a Tier 5 youth mobility&nbsp;scheme Visa (which replaced the previous UK working holvisa programme), go for this one, which according to 1stContact “allows people between the ages of 18 and 30, from participating countries, to live and work in the UK for two years.” It’s only available to citizens of certain countries (including Australia, New Zealand and Canada).</li></ul>
        <p class="f_body">But if you really need a proof of address...</p>
    </section>
    <section id="anchor04" ref="anchor04" class="
      boxed 
      pt-4 pl-7 pr-7 pb-10
      pt-lg-4 pl-lg-5 pr-lg-5 pb-lg-8
      pt-sm-2 pl-sm-2 pr-sm-2 pb-sm-7 
      mt-5 mb-5">
      <div class="color"></div>
      <h2 class="f_title mt-5 mb-7 mt-2-sm mb-sm-6">How to get a proof of address in the UK</h2>
        <p class="f_body">Banks and financial institutions, according to the <a href="https://www.monito.com/en/wiki/financial-crimes-enforcement-network-fincen?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Money Laundering</a> Regulations 2017, are required to ask for appropriate Identity Evidence when certain financial transactions take place. <a href="https://www.gov.uk/government/publications/proof-of-identity-checklist/proof-of-identity-checklist?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Source Gov.uk</a> By checking your ID (name) and a proof of address at your name, this minimizes the chance that the account is opened under a false identity. </p>
        <h3 class="f_subtitle_2">What document count as a proof of identity?</h3>
        <p class="f_body">They will require a proof of name, in the form of a Current Signed passport, Original Birth Certificate, EEA member state identity card, Current UK or EEA driving license, Registration card for self-employed individuals, Resident Permit issued by the Home office to EEA nationals, National Identity card or Firearms certificate.
        <h3 class="f_subtitle_2">What document count as a proof of address?</h3>
        <p class="f_body">Then, you might be required to provide 1 or 2 original documents to prove that you live where you claim to live (i.e. your residential address):</p>
        <ul class="f_body"><li>Utility bill, such as electric, satellite, television, landline or gas bill that have been issued in the last three month. Note that a mobile phone bill will not be accepted.</li><li>Local authority council tax bill for the current council tax year</li><li>Current UK driving licence</li><li>Bank, Building Society or Credit Union statement or passbook dated within the last three months</li><li>Mortgage statement (issued for the last full year)</li><li>Solicitors letter within the last three month confirming the property purchase (or the land registry confirmation of adress)</li><li>Council or housing association rent card or tenancy agreement for the current year</li><li>HMRC self-assessment letters or tax demand dated within the current financial year</li><li>Electoral Register entry</li><li>NHS Medical card or letter of confirmation from GP’s practice of registration with the surgery</li></ul>
        <p class="f_body">Note that credit card statements or provisional driving license will not be accepted.</p>
        <p class="f_body">According to the <a href="https://www.monito.com/en/wiki/uk-financial-conduct-authority-fca?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">Financial Conduct Authority (FCA)</a>, if you're unable to provide these documents, you can ask if they accept the following documents:</p>
        <ul class="f_body"><li>a letter from a care home manager or warden of sheltered accommodation or a refuge</li><li>a letter from the warden of a homeless shelter</li><li>a letter from a probation officer or a hostel manager</li><li>a letter from a prison governor</li><li>if you are a traveller, a letter from the local authority that verifies your address</li><li>if you are an international student, a passport or European Economic Area National Identity Card and letter of acceptance or of introduction from a body on the Department for Education list, or</li><li>if you are an asylum seeker, an application registration card</li></ul>
        <p class="f_body"><a href="https://www.fca.org.uk/consumers/opening-bank-account?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk
 &utm_content=main_content">https://www.fca.org.uk/consumers/opening-bank-account</a></p>
    </section>
  </section>
    <aside v-if="false" class="scroller"><div class="aside_widget"><div class="title fs-20 pl-1 pr-1 ls-1 f-anti">💡 Monito's Tip: Open a TransferWise Borderless Account
</div><p class="fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4">Just arrived in the UK or planning to move soon?<br/> Do you need to pay or get paid like a local but can't open a bank account without proof of address?</p><p class="fs-17 lh-4 f-anti fw-medium pl-2 pr-2 pt-4 mb-5">Open a <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F">TransferWise Borderless Account online</a> and get UK bank details, a multi-currency account and a debit Mastercard.</p><a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK&utm_source=internal&utm_medium=internal&utm_content=hero_widget&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Open your account now</a></div></aside>
<aside v-if="true" class="scroller">
  <div class="aside_widget mb-4">
    <div class="should excellent">
      <p><span>What you should do</span><b>Take your banking 100% online with TransferWise.</b> Most high-street banks won't allow you to open a bank account without a proof of residency, so we recommend going with the best online solution who will, like TranserWise Borderless account.</p>
      <a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta fw-bold f-anti f-19 ls-1">Take me to TransferWise</a>
    </div>
  </div>
  <div v-if="false" class="aside_widget">
    <div class="should bad">
      <p><span>What you should avoid</span><b>Don’t go with a high-street bank,</b> most won’t allow you to open a bank account without a proof of residency and are all around more expensive.</p>
      
    </div>
  </div>
</aside>
    <aside ref="scroll_widgets" class="scroller article_content">
      <div class="aside_widget">
        <h4 class="fw-demi-bold fs-16 pt-5 pb-1 ">Let's browse through the article</h4>
        <ul class="fw-demi-bold f-anti fs-16 pb-3 pt-0">
          <li class="active" @click="anchor01()">Introduction</li>
          <li @click="anchor02()">Monito’s recommendation<a target="_blank" rel="noopener" href="https://go.monito.com/transferwise-borderless?utm_campaign=ABTestBankUK_legacy&utm_source=internal&utm_medium=internal&utm_content=hero_widget_cta&link=https%3A%2F%2Fprf.hn%2Fclick%2Fcamref%3A1101l7rC2%2Fadref%3Aukaccount%2Fpubref%3A%25COOKIE_ID_TWP%2Fdestination%3Ahttps%253A%252F%252Ftransferwise.com%252Fgb%252Fborderless%252F" class="btn_cta hide fw-bold f-anti f-19 ls-1">Open a TransferWise Borderless Account</a></li>
          <li @click="anchor03()">How to open a UK account without proof of residency ?</li>
          <li @click="anchor04()">How to get a proof of address in the UK ?</li>
        </ul>
      </div>
    </aside>
   
  </main>
    
  <widget-faq>
      <ul class="shadow">
        <li>
          <h3>Which company offers a bank account in the UK if I don't have the proof of address? 🏦</h3>
          <p class="f_body">There are few companies that offer a bank account in the UK, even when you don't have a proof of address in the UK. With Monzo or Monese, you can open a UK bank account with just a few clicks. All the details about <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">opening a bank account in the UK without the proof of address</a>, you will find in our blog post. </p>
        </li>
        <li>
          <h3>What is the best UK bank accout for non residents?</h3>
          <p class="f_body">Expats moving to the UK 🇬🇧might find it difficult to open a traditional bank account. To open a bank account, you need a proof of address, which might be hard to get if you are a non-resident. Good news is that companies liked Monzo or Monese offer a UK bank account without proof of address. You can have a UK bank account with just a few clicks. <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">More info about UK bank account for non-residents you will find in our blog post</a>.</p>
        </li>
        <li>
          <h3>Is it possible to have Euro bank account in the UK? 💶</h3>
          <p class="f_body">Some UK banks offer bank account in Euro. However, the fees for such accounts are quite high. But we have good news - there is a possibility to open a bank account in Euro for free. Check out our <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">blog post about opening a bank account in the UK without proof of address</a> and get a free UK bank account in Euro. </p>
        </li>
        <li>
          <h3>What documents do I need to open a bank account in the UK? 📄  </h3>
          <p class="f_body">To open a UK bank account, you generally need two things:<br>1️. Proof of your identity - passport, drivers license, or national identity card. In general, if you are a foreign national, your best bet is to use your passport.<br>2. Proof of the address in the UK. It can be a recent utility bill, rental contract, council tax bill. Mobile phone bills are generally not accepted. <br><br>If you don't have a proof of address, have a look at our <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">blog post about opening a bank account in the UK</a>. </p>
        </li>
        <li>
          <h3>Can a foreigner open a bank account in the UK? 🇬🇧</h3>
          <p class="f_body">Foreigners can open a traditional bank account in the UK as long as they have proof of the address, which sometimes it's hard to get. Good news is that there are companies like Monzo or Monese which offer UK bank account even without the proof of the address. All the information about <a target="_blank" rel="noopener" href="https://www.monito.com/en/wiki/open-bank-account-uk-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=FAQ">opening a bank account in the UK you will find in our blog post</a>. </p>
        </li>
      </ul>
  </widget-faq>
  <widget-articles :articles="articles"><h1 class="fs-28 fw-bold f-anti mb-9 mb-sm-4 mt-sm-4">This might interest you too</h1></widget-articles>
  <app-footer></app-footer>

  </div>
</template>

<script>
  import '../assets/scss/_toolbox_fonts.scss'
  import '../assets/scss/_toolbox_margin_padding.scss'
  import '../assets/scss/_toolbox_layout.scss'
  
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import Footer from './Footer.vue'
  import Subhero from './Subhero.vue'
  import WidgetAuthor from './WidgetAuthor.vue'
  import WidgetFeaturedBlock from './WidgetFeaturedBlock.vue'
  import WidgetFeaturedOn from './WidgetFeaturedOn.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import WidgetFaq from './WidgetFaq.vue'
  import WidgetArticlesRelated from './WidgetArticlesRelated.vue'
  export default {
  	data() {
  		return {
  			herotype :'contentpage',
        scrollingActive : true,
        anchor : '01',
        urlBackground :'https://images.prismic.io/monito/595e5e4bf13c1e6e728aceae610bb5ed7b216739_bank-londong-metro-station.jpg',
        providers : [
          {logo: 'public/review_ria.png',url:'ria.com',score:'5.8'},
          {logo: 'public/review_worldremit.png',url:'paypal.com',score:'8.3'},
          {logo: 'public/review_paypal.png',url:'paypal.com',score:'5.1'},
          {logo: 'public/review_remitly.png',url:'paypal.com',score:'7.6'},
          {logo: 'public/review_transferwise.png',url:'paypal.com',score:'8.8'},
          {logo: 'public/review_skrill.png',url:'paypal.com',score:'8.3'}
        ],
        articles : [
          { cover: 'https://images.prismic.io/monito/2c88dce81622b53cdb86db00c5c24fcde3758a11_home-office-2452806_1280.jpg',
            url:'https://www.monito.com/en/wiki/best-way-freelancers-get-paid?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'The best way for freelancers to get paid',
            date_author:'Apr. 15, 2019  -  by François Briod'},

            { cover: 'https://images.prismic.io/monito/effa81034b062cc66ed8b15f32fd6e106112868e_buildings_usa.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-us-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'How to open a bank account online in the U.S. without proof of residency',
            date_author:'Mar. 28, 2019  -  by François Briod'},

          { cover: 'https://images.prismic.io/monito/f1e8a7c63bb75c8846f14a6ce4da502fbf2d3772_top-tips-for-digital-nomads-finance-money-transfers.png',
            url:'https://www.monito.com/en/wiki/digital-nomads-getting-finances-right?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'Digital Nomads — Getting Your Finances Right',
            date_author:'Feb. 28, 2020  -  by François Briod'},
          
          
          { cover: 'https://images.prismic.io/monito/a56593dc-c364-433e-b8af-63bca2948b2f_denise-jans--gmtAa0Q5MI-unsplash.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-australia-even-without-proof-residency?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'How to open a bank account online in Australia without proof of residency',
            date_author:'Jan. 20, 2020  -  by François Briod'},
          
          { cover: '',
            url:'https://www.monito.com/en/wiki/living-in-france',
            title:'Living in France',
            date_author:'Nov. 14, 2018'},
            { cover: 'https://images.prismic.io/monito/eaee3cd7169be1fe0363a708de2e97fa4622501c_best-international-bank-accounts-for-digital-nomads-laptop-money.jpg',
            url:'https://www.monito.com/en/wiki/best-international-bank-accounts-digital-nomads?utm_source=internal&utm_medium=internal&utm_campaign=ABTestBankUk&utm_content=related_content',
            title:'The best international bank accounts for digital nomads, travelers & expats',
            date_author:'Nov. 14, 2018'},
            { cover: 'https://images.prismic.io/monito/c6446110f7fd98ea86127c6981abf32927e07f5e_toronto.jpg',
            url:'https://www.monito.com/en/wiki/open-bank-account-canada-even-without-proof-residency',
            title:'How to open a bank account in Canada without proof of residency',
            date_author:'Jul. 17, 2019  -  by François Briod'}
          
         

        ]
  		}
  	},
    methods : {
      handleScroll(event){
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;

      var bodyRect = document.body.getBoundingClientRect(),
      container_width = this.$refs.main.clientWidth,
      aside = this.$refs.scroll_widgets.getBoundingClientRect(),
      anchor02 = this.$refs.anchor02.getBoundingClientRect(),
      anchor03 = this.$refs.anchor03.getBoundingClientRect(),
      anchor04 = this.$refs.anchor04.getBoundingClientRect(),
      scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
      left = scroll_zone.right,
      aside_width = this.$refs.scroll_widgets.clientWidth,
      scroll_zone_width = this.$refs.scroll_zone.clientWidth,
      aside_height = this.$refs.scroll_widgets.clientHeight,
      scroll_zone_height = this.$refs.scroll_zone.clientHeight,
     

    
      
      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = (offset_scroll_zone + scroll_zone_height);
      var windows_width = window.innerWidth;


      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;

      if(windows_width > 980){
        this.scrollingActive = true;
      } else {
        this.scrollingActive = false;
      }


        if (this.scrollingActive == true){
            if(y > (position_x_aside - 20 + 655)){
              if(y <= (bottom_main_content - aside_height - 20)){
                this.$refs.scroll_widgets.style.position = 'fixed';
                this.$refs.scroll_widgets.style.left = left+(container_width - (scroll_zone_width + aside_width)) + 'px';
                this.$refs.scroll_widgets.style.top = 20 + 'px';
              } else {
                this.$refs.scroll_widgets.style.top = ((scroll_zone_height - aside_height)) + 'px';
                this.$refs.scroll_widgets.style.position = 'absolute';
                this.$refs.scroll_widgets.style.left = '';
              }
            } else {
              this.$refs.scroll_widgets.style.top = '655px';
              this.$refs.scroll_widgets.style.position = 'absolute';
              this.$refs.scroll_widgets.style.left = '';
            }
        } else {
              this.$refs.scroll_widgets.style.position = 'relative';
              this.$refs.scroll_widgets.style.left = '';
              this.$refs.scroll_widgets.style.top = '';
        }

        if(anchor02.top < 190 && anchor03.top > 200) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(2)").addClass('active');
        } else if (anchor03.top < 200 && anchor04.top > 300) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(3)").addClass('active');
        } else if (anchor04.top < 300) {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(4)").addClass('active');
        } else if (anchor02.top > 190 ) { 
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li:nth-child(1)").addClass('active');
        } else {
          $(".article_content ul li").removeClass('active');
          $(".article_content ul li").css(({"background":""}));
          $("#anchor02").css(({"padding-right": "","background":"","left":"", "padding-left":""}));
        }

        if(anchor03.top < 200){
         $(".article_content ul li a.btn_cta").removeClass('hide');
         $(".article_content ul li a.btn_cta").addClass('anime');
        } else {
          $(".article_content ul li a.btn_cta").addClass('hide');
        }  
  
      },
      anchor01(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor01").offset().top - 40
        }, 1000);

      },
      anchor02(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor02").offset().top - 142
        }, 1000);
       
      },
      anchor03(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor03").offset().top - 40
        }, 1000);
      },
      anchor04(){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#anchor04").offset().top - 40
        }, 1000);
      }
    },  
    components: {
      'app-navigation' : Nav,
      'app-hero-section' : Hero,
      'app-subhero-section' : Subhero,
      'widget-text-featured-block' : WidgetFeaturedBlock,
      'widget-featured-on' : WidgetFeaturedOn,
      'widget-providers' : WidgetProviders,
      'widget-articles' : WidgetArticlesRelated,
      'app-footer' : Footer,
      'widget-faq' : WidgetFaq,
      'widget-author' : WidgetAuthor
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }
  }
</script>

<style lang="scss">



  main {
    position: relative;
    z-index: 10000;
    margin-top: -290px;


    @media ($tablet_portrait) {
        margin-top: -170px;
    }
    @media ($mobile) {
        margin-top: -150px;
    }
  }



  .scroller {
    width: 352px;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 232px;
  }

  

  .scroller.article_content {
    top: 655px;

    .aside_widget {
      padding: 0;
    }

    h4 {
      color: #676767;
    }
  }

  .article_content ul {
    list-style: none;
    padding-left: 0;
    margin-left: 0;

    li {
      padding: 12px 50px;
      color: #353C45; 
      cursor: pointer;
      transition: all 0.2s ease;

      a {
        background: #0CC3CA;
        text-align: center;

        &.hide {
          display: none!important;
        }

        &:hover {
          background: #17d5dc;
        }

        &.anime {
          animation-name: apparition_btn_cta;
          animation-duration: 1s;
          position: relative;

          @keyframes apparition_btn_cta {
            from {bottom: -10px; opacity: 0;}
            to {bottom: 0; opacity: 1;}
          }
        }
      }

      &:hover {
        background: #D3F5F560;
      }


      &.active {
        background: #D3F5F5;
        color: #004660;
        position: relative;
        padding-top: 24px;
        padding-bottom: 24px;
        cursor: default;

        &:after {
          content: '';
          width: 0;
          height: 0;
          border-top: 35px solid transparent;
          border-bottom: 37px solid transparent;
          border-right: 14px solid #D3F5F5;
          left: -14px;
          top: calc(50% - 35px);
          position: absolute;
        }  
      }
    }
  }

  @media ($tablet_portrait) {
    .article_content {
      display: none;
    }
    body {
      width: 100%;
      overflow: scrollY;
    }
    main {
      width: 100%;
      h1 {
        text-align: center;
      }
    }

    .scroller {
      width: 90%;
      margin-left: 5%;
      position: relative!important;
      top: 0;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ContentPage.vue